import { Colors, IconButton } from 'library';
import { ShiftProviderUser } from 'models';
import React, { useState } from 'react';
import EditPayModal from './EditPayModal';
import { Edit } from '@mui/icons-material';

export function EditPay({
    visible,
    pay,
    jobId,
    provider,
    refresh,
}: {
    visible: boolean;
    pay?: number | null;
    jobId: number;
    provider?: ShiftProviderUser;
    refresh: () => void;
}) {
    const [editPayModalOpen, setEditPayModalOpen] = useState(false);
    if (!visible) {
        return null;
    }
    return (
        <>
            <IconButton
                icon={Edit}
                onClick={() => {
                    setEditPayModalOpen(true);
                }}
                backgroundColor={Colors.darkNavy}
                color={Colors.white}
                size={26}
                tooltip="Edit pay rate"
                style={{ marginLeft: 3 }}
            />
            <EditPayModal
                open={editPayModalOpen}
                onClose={() => {
                    setEditPayModalOpen(false);
                }}
                initialPay={pay ?? 0}
                jobId={jobId}
                workerUserId={provider?.id ?? 0}
                refresh={refresh}
            />
        </>
    );
}
